// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"365ffb6e","154":"383a7d3b","371":"4e4e7283","401":"2b48ed35","409":"1f55ddef","572":"e441c5a0","858":"ea62db88"}[chunkId] + ".chunk.js";
};